import VueModal from '../components/Modal.vue';

export default {
  install(Vue) {

    Vue.component('vue-modal', VueModal);

    Vue.prototype.$modal = {
      open(name = null, data = null) {
        Event.fire('toggleModal', name, true, data);
      },

      close(name = null, data = null) {
        Event.fire('toggleModal', name, false, data);
      },

      toggle(name = null, data = null) {
        Event.fire('toggleModal', name, undefined, data);
      },
    };

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        Vue.prototype.$modal.close();
      }
    });
  },
};
